define([
	"dojo/_base/declare",
	"dojo/store/Memory",
	"csi/action/EmailController",
	"csi/xml"
], function(declare,Memory,EmailController,xml) {

	return declare(EmailController, {

		getAttachmentsStore: function() {
			// summary: returns the attachments' store
			return new Memory({
				idProperty: "$",
				nameProperty: "Name",
				labelProperty: "Name",
				data: [
				    {$: "centric:", Name: this._getAttachmentName()}
				]
			});
		},

		getInitialValues: function() {
			// summary: get initial values for Email form
			var initialValues = this.inherited(arguments);

			initialValues.attachments = ["centric:"];

			return initialValues;
		},

		toWriter: function() {
			// summary: set values to email message
			var call = this.inherited(arguments);

			call.setModuleOperation("Specification", "EmailDataPackageZip");
			call.addParameter("URL", xml.ATTR_REF, this.m_urlNode);
			call.addParameter("AttachmentName", xml.ATTR_STRING, this._getAttachmentName());

			return call;
		},

		_getAttachmentName: function() {
			var node = this.getNode();
			return node.$Name+".zip";
		}
	});
});